export const alloysPartnersShopifyAppGroupIdBridges = "/alloys/partners/shopify/:app_group_id/bridges";
